var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalaryBoostingSkill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 183,
    viewBox: "0 0 183 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.062 19.0625L171.562 49.5625V19.0625H141.062Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.938 133.438V171.562H163.937V133.438H102.938Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9375 49.5625L49.5625 57.1875L68.625 49.5625L49.5625 87.6875L80.0625 118.187V156.312L49.5625 171.562H34.3125L3.8125 156.312V118.187L34.3125 87.6875L15.25 49.5625L34.3125 57.1875L41.9375 49.5625Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.823 159.431L96.7005 160.765L88.6104 123.502L148.223 110.562L153.186 133.437H102.938L102.823 159.431Z",
    fill: "#BBD8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5625 87.6874L59.0938 68.6172L49.5625 72.4297L41.9375 64.8047L34.3125 72.4297L24.7812 68.6172L34.3125 87.6874H49.5625Z",
    fill: "#BBD8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3125 102.93L3.8125 133.43V156.312L34.3125 171.562H49.5625L80.0625 156.312V133.43L49.5625 102.93H34.3125Z",
    fill: "#BBD8FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.25 83.875L110.562 49.5625L125.812 64.8125L156.312 34.3125",
    stroke: "#092F63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M141.062 19.0625L171.562 49.5625V19.0625H141.062Z",
    stroke: "#092F63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61 87.6875H19.0625",
    stroke: "#092F63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1875 118.188H32.4062L26.6875 125.812L32.4062 133.437H51.4687L57.1875 141.062L51.4687 148.687H26.6875",
    stroke: "#092F63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9375 118.187V110.562",
    stroke: "#092F63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9375 156.312V148.688",
    stroke: "#092F63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9375 49.5625L49.5625 57.1875L68.625 49.5625L49.5625 87.6875L80.0625 118.187V156.312L49.5625 171.562H34.3125L3.8125 156.312V118.187L34.3125 87.6875L15.25 49.5625L34.3125 57.1875L41.9375 49.5625Z",
    stroke: "#092F63",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M102.938 133.438V171.562H163.937V133.438H102.938Z",
    stroke: "#092F63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M133.437 148.688L129.625 152.5L133.437 156.312",
    stroke: "#092F63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M133.438 148.688L137.25 152.5L133.438 156.312",
    stroke: "#092F63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M153.186 133.437L148.223 110.562L88.6104 123.502L96.7005 160.765L102.823 159.431",
    stroke: "#092F63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaryBoostingSkill);
export default __webpack_public_path__ + "static/media/salaryBoostingSkill.1b996e713aaf9e59229340f3bc6b024f.svg";
export { ForwardRef as ReactComponent };